import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageToggle from '../components/LanguageToggle';

const LoginPage = () => {
  const { login, isAuthenticated, processingSession } = useAuth();
  const navigate = useNavigate();
  const { t, language } = useLanguage();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  if (processingSession) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">{t('loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex items-center justify-center p-4">
      <LanguageToggle />
      
      <div className="max-w-md w-full">
        {/* Logo and Title */}
        <div className="text-center mb-8">
          <div className="text-6xl mb-4">🎓</div>
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            {language === 'tr' ? 'Hoş Geldiniz' : 'Welcome'}
          </h1>
          <p className="text-gray-600 text-lg">
            {t('dashboard_title')}
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
            {language === 'tr' ? 'Giriş Yap' : 'Sign In'}
          </h2>
          
          <button
            onClick={login}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-4 rounded-xl hover:shadow-lg transition-all duration-300 font-semibold text-lg flex items-center justify-center space-x-3"
            data-testid="google-login-button"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span>{language === 'tr' ? 'Google ile Giriş Yap' : 'Sign in with Google'}</span>
          </button>

          <div className="mt-6 text-center text-sm text-gray-600">
            {language === 'tr' ? (
              <p>Giriş yaparak <a href="#" className="text-blue-600 hover:underline">Kullanım Koşulları</a> ve <a href="#" className="text-blue-600 hover:underline">Gizlilik Politikasını</a> kabul etmiş olursunuz.</p>
            ) : (
              <p>By signing in, you agree to our <a href="#" className="text-blue-600 hover:underline">Terms of Service</a> and <a href="#" className="text-blue-600 hover:underline">Privacy Policy</a>.</p>
            )}
          </div>
        </div>

        {/* Features */}
        <div className="mt-8 grid grid-cols-3 gap-4 text-center">
          <div className="bg-white rounded-xl p-4 shadow-lg">
            <div className="text-3xl mb-2">🌉</div>
            <p className="text-sm text-gray-600 font-semibold">{language === 'tr' ? 'Köprü' : 'Bridge'}</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-lg">
            <div className="text-3xl mb-2">🌍</div>
            <p className="text-sm text-gray-600 font-semibold">{language === 'tr' ? 'Global & Lokal' : 'Global & Local'}</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-lg">
            <div className="text-3xl mb-2">📊</div>
            <p className="text-sm text-gray-600 font-semibold">{language === 'tr' ? 'AP + TYT/AYT' : 'AP + TYT/AYT'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;